(function () {
  'use strict';

  var root = document.documentElement;
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var headerTopFrame = null;

  function getBar() {
    return document.querySelector('[data-announcement-bar]');
  }

  function getHeader() {
    return document.querySelector('.site-header');
  }

  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function isVisibleForViewport(bar) {
    if (!bar || bar.hidden) return false;
    return mobileQuery.matches
      ? bar.getAttribute('data-show-mobile') === 'true'
      : bar.getAttribute('data-show-desktop') === 'true';
  }

  function syncHeaderSection() {
    var header = getHeader();
    var previousSections = document.querySelectorAll('.dz-header-section');

    Array.prototype.forEach.call(previousSections, function (section) {
      if (!header || !section.contains(header)) section.classList.remove('dz-header-section');
    });

    if (!header) return;

    var section = header.closest('.shopify-section, [id^="shopify-section-"]');
    if (section) section.classList.add('dz-header-section');
  }

  function syncHeaderTop() {
    var bar = getBar();
    var top = 0;

    if (isVisibleForViewport(bar)) {
      top = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
    }

    root.style.setProperty('--dz-header-top', top + 'px');
  }

  function requestHeaderTopSync() {
    if (headerTopFrame !== null) return;

    headerTopFrame = window.requestAnimationFrame(function () {
      syncHeaderTop();
      headerTopFrame = null;
    });
  }

  function syncAnnouncement() {
    var bar = getBar();
    var visible = isVisibleForViewport(bar);
    var desktopHeight = visible && bar ? bar.getAttribute('data-desktop-height') : '0';
    var mobileHeight = visible && bar ? bar.getAttribute('data-mobile-height') : '0';

    document.body.classList.toggle('has-announcement', visible);
    root.style.setProperty('--dz-announcement-height', desktopHeight + 'px');
    root.style.setProperty('--dz-announcement-mobile-height', mobileHeight + 'px');
    syncHeaderTop();
  }

  function bindBar(bar) {
    if (!bar || bar.getAttribute('data-announcement-bound') === 'true') return;
    bar.setAttribute('data-announcement-bound', 'true');

    var sectionId = bar.getAttribute('data-section-id') || 'global';
    var storageKey = 'dz-announcement-dismissed-' + sectionId;

    if (!isDesignMode()) {
      try {
        if (window.sessionStorage.getItem(storageKey) === 'true') bar.hidden = true;
      } catch (error) {}
    }

    var close = bar.querySelector('[data-announcement-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.hidden = true;
        if (!isDesignMode()) {
          try { window.sessionStorage.setItem(storageKey, 'true'); } catch (error) {}
        }
        syncAnnouncement();
      });
    }
  }

  function init() {
    var bar = getBar();
    bindBar(bar);
    syncHeaderSection();
    syncAnnouncement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('scroll', requestHeaderTopSync, { passive: true });
  window.addEventListener('resize', requestHeaderTopSync, { passive: true });
  window.addEventListener('pageshow', init);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncAnnouncement);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(syncAnnouncement);
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 0);
  });
  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(init, 0);
  });
  document.addEventListener('shopify:section:select', init);
})();
